import axiosHttp from "services/axiosHttp";

const { createSlice, createAsyncThunk } = require("@reduxjs/toolkit");

//action
export const fetchPermissionModule = createAsyncThunk("userManagement/fetchPermissionModule", async () => {
	const response = await axiosHttp.get(`permission/list/admin`);
	return response.data.data;
});

const userManagementPermissionListSlice = createSlice({
	name: "userManagementPermissionList",
	initialState: {
		isLoading: false,
		data: null,
		error: null,
	},

	reducers: {
		resetStatePermissionList: (state) => {
			state.isLoading = false;
			state.error = null;
			state.data = null;
		},
	},

	extraReducers: (builder) => {
		builder.addCase(fetchPermissionModule.pending, (state, action) => {
			state.isLoading = true;
		});

		builder.addCase(fetchPermissionModule.fulfilled, (state, action) => {
			state.isLoading = false;
			state.data = action.payload;
		});
		builder.addCase(fetchPermissionModule.rejected, (state, action) => {
			state.isLoading = false;
			state.error = action.payload;
		});
	},
});

export const { resetStatePermissionList } = userManagementPermissionListSlice.actions;
export default userManagementPermissionListSlice.reducer;
